(() => {
  if (window.__dripstockVariantClickSoundBound) return;
  window.__dripstockVariantClickSoundBound = true;

  let audioContext = null;
  let lastPlayedAt = 0;

  function playVariantClickSound() {
    if (window.DripstockSound && !window.DripstockSound.enabled()) return;
    const nowMs = Date.now();
    if (nowMs - lastPlayedAt < 90) return;
    lastPlayedAt = nowMs;

    try {
      const AudioCtx = window.AudioContext || window.webkitAudioContext;
      if (!AudioCtx) return;

      if (!audioContext) audioContext = new AudioCtx();
      if (audioContext.state === 'suspended') audioContext.resume();

      const now = audioContext.currentTime;
      const osc = audioContext.createOscillator();
      const gain = audioContext.createGain();

      osc.type = 'sine';
      osc.frequency.setValueAtTime(980, now);
      osc.frequency.exponentialRampToValueAtTime(1180, now + 0.035);

      gain.gain.setValueAtTime(0.0001, now);
      gain.gain.exponentialRampToValueAtTime(0.026, now + 0.004);
      gain.gain.exponentialRampToValueAtTime(0.0001, now + 0.055);

      osc.connect(gain);
      gain.connect(audioContext.destination);
      osc.start(now);
      osc.stop(now + 0.06);
    } catch (error) {}
  }

  let enforcingOversized = false;

  function enforceOversizedOnly(scope) {
    const base = scope && scope.querySelectorAll ? scope : document;
    const pickers = [];

    if (base.matches && base.matches('variant-picker')) pickers.push(base);
    if (base.querySelectorAll) base.querySelectorAll('variant-picker').forEach(p => pickers.push(p));

    pickers.forEach((picker) => {
      const fitRadios = Array.from(picker.querySelectorAll(
        'input[data-option-name="Fit"], input[data-option-name="Cut"]'
      ));
      const oversizedRadio = fitRadios.find((input) =>
        String(input.value || '').toLowerCase().includes('oversized') && !input.disabled
      );

      if (oversizedRadio && !oversizedRadio.checked) {
        enforcingOversized = true;
        oversizedRadio.click();
        enforcingOversized = false;
      }

      picker.querySelectorAll('select').forEach((select) => {
        const oversizedOption = Array.from(select.options).find((option) => {
          const optionName = String(option.dataset.optionName || '').toLowerCase();
          return (optionName === 'fit' || optionName === 'cut') &&
            String(option.value || '').toLowerCase().includes('oversized') &&
            !option.disabled;
        });

        if (oversizedOption && select.value !== oversizedOption.value) {
          enforcingOversized = true;
          select.value = oversizedOption.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
          enforcingOversized = false;
        }
      });
    });
  }

  function isSupportedOptionName(name) {
    const value = String(name || '').trim().toLowerCase();
    return value === 'size' || value === 'color';
  }

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;


    const label = target.closest('variant-picker .variant-option__button-label');
    if (!label) return;

    const input = label.querySelector('input[data-option-name]');
    if (!input || input.disabled || input.getAttribute('aria-disabled') === 'true') return;
    if (!isSupportedOptionName(input.dataset.optionName)) return;

    if (!enforcingOversized) playVariantClickSound();
  });

  document.addEventListener('change', (event) => {
    const target = event.target;
    if (!(target instanceof HTMLSelectElement)) return;
    if (!target.closest('variant-picker')) return;

    const selected = target.selectedOptions && target.selectedOptions[0];
    const optionName = selected?.dataset?.optionName || target.dataset.optionName || '';
    if (!isSupportedOptionName(optionName)) return;

    if (!enforcingOversized) playVariantClickSound();
  });

  function bootOversizedOnly() {
    enforceOversizedOnly(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootOversizedOnly, { once: true });
  } else {
    bootOversizedOnly();
  }

  document.addEventListener('shopify:section:load', (event) => {
    enforceOversizedOnly(event.target);
  });

  const oversizedObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node && node.nodeType === 1) enforceOversizedOnly(node);
      });
    });
  });

  if (document.documentElement) {
    oversizedObserver.observe(document.documentElement, { childList: true, subtree: true });
  }
})();